import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const ReplenishmentConfigPageRBAC = {
  pageID: 'a24e18e40a4c2f7ff71ed46e1f545946',
  elementID: {
    BtnUpdateConfig: 'c5564fb2ab4f795be60d49c03d11a477',
    BtnBulkUpload: '22ae8abe07cfcf2ab3c451ff14545ce5',
  },
} as const

export const useRBACReplenishmentConfigPage = createUseRBAC(ReplenishmentConfigPageRBAC.elementID)

export type UseRBACReplenishmentConfigPageType = ReturnType<typeof useRBACReplenishmentConfigPage>
